import React, { FC, createContext, ReactNode } from 'react';

// Define the shape of the context data.
interface DataPageContextData {
  dataPage: string;
  setDataPage: (page: string) => void;
}

interface DataPageProviderProps {
  children: ReactNode;
}

// Create the context with initial values.
export const DataPageContext = createContext<DataPageContextData>({
  dataPage: '',
  setDataPage: () => {},
});


// Context provider component.
export const DataPageProvider: FC<DataPageProviderProps> = ({ children }) => {
  const [dataPage, setDataPage] = React.useState('');

  const setDataPageHandler = (value: React.SetStateAction<string>) => {
    setDataPage(value)
  }

  return (
    <DataPageContext.Provider value={{dataPage, setDataPage: setDataPageHandler}}>
      {children}
    </DataPageContext.Provider>
  );
};
